import { Row } from 'components/Containers/Row/Row';
import React from 'react';
import { dti } from 'helpers/cmp';
import 'components_ZeroState/ZeroState.scss';
import { Image } from 'components/Image/Image';

const ZeroState = props => {
  return (
    <>
      <Row
        datatestid={dti(props.datatestid, 'zero-state')}
        className="zeroState text-center"
      >
        <Image
          data-testid={props.datatestid + '-zero-img'}
          imgClass="zero-image"
        />
        <div className="zero-header">{props.title}</div>
        <div className="zero-description">{props.description}</div>
      </Row>
    </>
  );
};

ZeroState.defaultProps = {
  datatestid: null,
  title: 'No Results Found',
  description: 'Try adjusting your filter to find what you’re looking for.',
};

export default ZeroState;
